import * as logger from 'universal-logger';
import * as defaultModuleMap from './modules';

// TODO: move all of this into cms-modules.saga
const getModuleName = moduleDef => (moduleDef.type || '').toLowerCase();

export const findModule = (moduleMap, moduleDef) => {
  const moduleName = getModuleName(moduleDef);
  const module = moduleMap[moduleName] || null;
  if (!module) {
    logger.warn(`module [${moduleName}] is unknown`);
  }
  return module;
};

const moduleMapper = (moduleMap, state, modules) =>
  (modules || [])
    .map(moduleDef => [findModule(moduleMap, moduleDef), moduleDef])
    .filter(([module]) => module)
    .map(([module, moduleDef]) => {
      // This is disappearing in an upcoming PR,
      // since all modules will map themselves via
      // mapStateToProps.
      const props = module.propMapper ? module.propMapper(state, moduleDef) : moduleDef;

      const propModules = props.modules || props.items;

      return {
        Component: module,
        cmsModuleId: moduleDef.contentfulId,
        props: propModules ? { ...props, modules: moduleMapper(moduleMap, state, propModules) } : props,
      };
    });

/**
 * Converts a list of modules returned from Contentful into a list of React
 * components and their props, to be passed to <CmsModules />.
 *
 * Do not attempt to use this function within a CMS module, or you'll find
 * yourself with a circular dependency issue. To convert nested modules into
 * components, your Contentful content type needs to be set up to have your
 * child modules on a field called `modules`, and they'll be recursively
 * converted into the list of components that can be consumed by <CmsModules />.
 * **Any other field name will not be converted**.
 */
export const cmsDataToModuleArray = (state, cmsData, moduleMap = defaultModuleMap) =>
  moduleMapper(moduleMap, state, cmsData.modules);
